import { useEffect, useState } from 'react';
import { Flex, Text, theme } from '../2022-component-library';
import { Icon } from '../component-library';
import { logmarToSnellen, logmarToAmericanSnellen, logmarToMetric } from '../helpers/data';
import { useMediaQuery } from '../helpers/useMediaQuery';

const formats = [
  { name: { sm: 'EU Snellen', md: 'European Snellen' }, conversionTable: logmarToSnellen },
  { name: { sm: 'Metric', md: 'Metric' }, conversionTable: logmarToMetric },
  { name: { sm: 'US Snellen', md: 'American Snellen' }, conversionTable: logmarToAmericanSnellen },
];

const AcuityResultsTable = ({ title, logmarSize }) => {
  const [selectedFormatIndex, setSelectedFormatIndex] = useState(0);
  const [alternativeFormatValue, setAlternativeFormatValue] = useState('N/A');
  const smallScreen = useMediaQuery('(max-width: 650px)');
  const mediumScreen = useMediaQuery('(max-width: 975px)');

  const changeFormat = (direction) => {
    if (direction === 'prev') return setSelectedFormatIndex((index) => (index + 1) % formats.length);
    if (direction === 'next') return setSelectedFormatIndex((index) => (index - 1 + formats.length) % formats.length);
  };

  useEffect(() => {
    if (Number(logmarSize) || logmarSize === '0.00') {
      const convertedLogmar = formats.at(selectedFormatIndex).conversionTable[Number(logmarSize).toFixed(1)] || 'N/A';
      setAlternativeFormatValue(convertedLogmar);
    }
  }, [selectedFormatIndex, logmarSize]);

  return (
    <Flex column centered width='35%' maxWidth='250px'>
      <Header title={title} sm={smallScreen} md={mediumScreen} />
      <Row md={mediumScreen}>
        <Text>{logmarSize > 1 ? '>1.00' : logmarSize || 'N/A'}</Text>
      </Row>
      <Row md={mediumScreen} backgroundColor={'#d1d1d1'}>
        <Text>{alternativeFormatValue}</Text>
      </Row>
      <Row md={mediumScreen} backgroundColor={theme.colors.neutralDark} color='#fff' justifyContent='space-between'>
        <Icon icon={'Chevron-left'} size={15} color='#fff' style={{ cursor: 'pointer' }} onClick={() => changeFormat('prev')} />
        <Text>{formats.at(selectedFormatIndex).name[smallScreen ? 'sm' : 'md']}</Text>
        <Icon icon={'Chevron-right'} size={15} color='#fff' style={{ cursor: 'pointer' }} onClick={() => changeFormat('next')} />
      </Row>
    </Flex>
  );
};

const Header = ({ title, sm, md }) => {
  const paddingValue = md ? '1rem' : '1.5rem';

  return (
    <Flex centered backgroundColor={theme.colors.primary} padding={paddingValue} width='100%'>
      <Text color='#fff' fontWeight='bold'>
        {sm && title[0] !== 'B' ? title.charAt(0) : title}
      </Text>
    </Flex>
  );
};

const Row = ({ children, md, ...props }) => {
  return (
    <Flex centered width='100%' padding={md ? '1rem' : '1.5rem'} {...props}>
      {children}
    </Flex>
  );
};

export default AcuityResultsTable;
